module.exports = __webpack_public_path__ + "static/img/premiumCard.f399c2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lockscreens/premiumCard.png
// module id = VOOD
// module chunks = 1